define.alias("ember-intl/helpers/format-time", "settings/helpers/format-time");